<template>
  <div>
    <div class="vue-outages-table-mobile-wrap">
      <b-spinner v-if="!dataReady && utilityOutagesSortComplete" class="ajax-spinner"></b-spinner>
      <div class="utilities-wrap" v-if="dataReady">
          <ul class="utilities" v-if="utilityOutages && utilityOutages.length">
            <li class="utility"
            v-for="utility in utilityOutages"
            :key="utility.utilityId" :value="utility.utilityId">
              <div class="utility-content">
                  <div
                  class="utility-header"
                  v-on:click="showCounties(utility)">
                      <span class="name">{{utility.name}}</span>
                      <span class="customers">- {{utility.totalCustomers}} customers</span>
                      <span class="arrows">
                        <i class="arrow down" v-if="!utility.countiesVisible"></i>
                        <i class="arrow up" v-if="utility.countiesVisible"></i>
                      </span>
                  </div>
                  <div
                  class="utility-county-data"
                  v-bind:class="{countiesVisible: utility.countiesVisible}">
                      <p class="date">As of: {{utility.asOfDateFormatted}}</p>
                      <ul class="counties">
                          <li
                          class="county"
                          v-for="county in utility.counties" :key="county.countyId" :value="county.countyId">
                            <span class="name">{{county.name}}:</span><span>{{county.customerCount}}</span>
                          </li>
                      </ul>
                  </div>
              </div>
            </li>
          </ul>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import API from "@/services/api";

export default {
  name: "OutagesTableMobile",
  async created() {
    await this.GetData();
    if (!this.utilityOutages || !this.utilityOutages.length) {return; }
    this.formatAsOfDates();
    this.sortUtilityOutages();
    this.dataReady = true;
  },
  data() {
    return {
      counties: [],
      utilityOutages: [],
      dataReady: false,
      utilityOutagesSortComplete: false
    };
  },
  methods: {
    stringToNumber(stringAsNumber) {
      return parseInt(stringAsNumber, 10);
    },
    hideAllCountyData() {
      this.utilityOutages.forEach(utilityOutage => utilityOutage.countiesVisible = false);
    },
    formatAsOfDates() {
      this.utilityOutages.forEach(utilityOutage => {
        utilityOutage.asOfDateFormatted = `${moment(new Date(utilityOutage.asOfDate)).format('M/DD/YY - h:mm a')}`;
      });
    },
    async GetData() {
      try {
        await API.GetUtilityOutagesWithCounties(null, true)
        .then(outages => this.utilityOutages = outages || []);
      } catch (err) {
          console.log("Unable to fetch utilityOutage data");
          console.log(err);
      }
    },
    sortUtilityOutages(){
      let noOutages = [];
      let haveOutages = [];

      this.utilityOutages.forEach(utilityOutage => {
        if (!utilityOutage.totalCustomers || this.stringToNumber(utilityOutage.totalCustomers)  === 0) {
          noOutages.push(utilityOutage);
        } else {
          haveOutages.push(utilityOutage);
        }
      });

      noOutages.sort((a, b) => a.name > b.name ? 1 : -1);
      haveOutages.sort((a, b) => this.stringToNumber(a.totalCustomers)  < this.stringToNumber(b.totalCustomers) ? 1 : -1);
      this.utilityOutages = haveOutages.concat(noOutages);
      this.utilityOutagesSortComplete = true;
    },
    showCounties(utility) {
      utility.showCountyCached = utility.countiesVisible;
      this.hideAllCountyData();

      if (utility.showCountyCached) {
        utility.countiesVisible = undefined;
      } else {
        utility.countiesVisible = true;
      }

      this.$forceUpdate();
      utility.showCountyCached = undefined;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../assets/css/partials/_variables.scss";

.vue-outages-table-mobile-wrap{
    position: relative;
    min-height: 500px;

  .ajax-spinner{
    position: absolute;
    top: 80px;
    left: 30%;
    height: 150px;
    width: 150px;
    color: #fbd850
  }

  .utilities-wrap{
    .utilities{
      .utility{
        .utility-content{
          .utility-header{
            padding: 10px;
            background-color: #D8D9D9;

            span {
              &.name{
                font-weight: bold;
                margin-right: 5px;
              }

              &.customers{
                margin-right: 5px;
              }

              &.arrows{
                position: absolute;
                right: 20px;

                .arrow {
                  border: solid $navy;
                  border-width: 0 3px 3px 0;
                  display: inline-block;
                  padding: 3px;

                  &.up {
                    transform: rotate(-135deg);
                    -webkit-transform: rotate(-135deg);
                  }

                  &.down {
                    transform: rotate(45deg);
                    -webkit-transform: rotate(45deg);
                  }
                }
              }
            }
          }

          .utility-county-data{
            display: none;
            padding: 10px;
            background-color: $white;

            &.countiesVisible{
              display: block;
            }

            .date{
              border-bottom: 1px solid $modalGrey;
              padding-bottom: 10px;
            }

            .counties{
              .county{
                .name{
                  margin-right: 5px;
                  font-weight: bold;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>